/* eslint-disable spaced-comment */
export enum HistoryTypeEnum {
    /*معتمد وتم إصدار وثيقة العقد*/
    IssueContract = 1,
    /*معتمد وتم تعديل بيان سداد الدفعات وتواريخ الاستحقاق*/
    UpdateBatch = 2,
    /*انتهاء مدة العقد*/
    Expired = 3,
    /*مغلق لتسوية العقد*/
    Closed = 4,
    /*ملغى بواسطة ({0})*/
    Cancelled = 5
}
